<template>
  <v-app>

    <!-- HEADER -->
    <v-app-bar
      app
      color="primary"
      dark
      clipped-left
    >
      <v-app-bar-nav-icon v-if="isLogin" @click="miniVariant = !miniVariant"/>
      <v-img
        max-width="35"
        max-height="35"
        :src="require('./assets/ic_new_holland.png')"
        class="ml-3 mr-3"
      />
      <v-toolbar-title>CNH Mobile App Administration</v-toolbar-title>
      <v-spacer/>
      <v-icon v-if="isLogin" dark class="mr-1">mdi-account</v-icon>
      <v-item-group>
        <v-item v-if="isLogin">
          <div>{{ user }}</div>
        </v-item>
      </v-item-group>
      <v-btn class="ml-5" v-if="isLogin" @click="logout" color="blue darken-4">
        Log out
        <v-icon dark right size="large">mdi-logout</v-icon>
      </v-btn>
    </v-app-bar>

    <!-- NAVIGATION BAR -->
    <v-navigation-drawer
      clipped
      app
      v-if="isLogin"
      dark
      color="blue darken-4"
      :mini-variant="miniVariant"
      permanent
    >
      <v-list class="mt-3">
        <v-list-item-group v-model="currentRouteId">
          <v-list-item
            v-for="link in links"
            :key="link.title"
            link
            @click="redirectToContent(link.name)"
          >
            <v-list-item-icon>
              <v-icon>{{ link.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ link.name }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>

    <!--CONTENT -->
    <v-content>
      <v-container fluid>
        <router-view class="router pa-3"></router-view>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
  import auth from '@/services/api/auth-api';
  import userApi from '@/services/api/user-api';

  export default {
    name: 'App',

    data () {
      return {
        isLogin: false,
        miniVariant: false,
        windowWidth: null,
        user: null,
        currentRouteId: 2,       
        links: [
          {
            icon: 'mdi-account-supervisor',
            title: 'User Groups',
            name: 'UserGroups'
          },
          {
            icon: 'mdi-content-copy',
            title: 'Templates',
            name: 'Templates'
          },
          {
            icon: 'mdi-bell',
            title: 'Notifications',
            name: 'Notifications'
          }
        ],
        headers: [
          { text: 'Title', value: 'calories' },
          { text: 'Status', value: 'fat' },
          { text: 'Last modified', value: 'carbs' },
          { text: 'Sent to', value: 'protein' },
          { text: 'Action', value: 'iron' }
        ]
      }
    },

    mounted() {
      this.setIsLogin();
      this.getUser();
    },

    updated() {
      this.setIsLogin();
      this.getUser();    

      // On check à chaque update si la route a changé pour indiquer dans quelle section on se trouve
      if (this.$router.currentRoute.path.includes('/userGroups')) {
        this.currentRouteId = 0;
      } else if (this.$router.currentRoute.path.includes('/templates')) {
        this.currentRouteId = 1;
      } else if (this.$router.currentRoute.path.includes('/notifications')) {
        this.currentRouteId = 2;
      }
    },

    methods: {
      redirectToContent(name) {
        this.$router.push({name});
      },

      async setIsLogin() {
        this.isLogin = localStorage.getItem('TOKEN') !== null;
      },

      async getUser() {
        if (this.isLogin) {
          let user = await userApi.getMe();
          this.user = user.data.username;
        }
      },

      toggleMenu() {
        this.miniVariant = !this.miniVariant;
      },

      async logout() {
        try {
          await auth.logout();
          this.$router.push({ name: 'Login' });
        } catch (error) {
          throw error;
        }
      }
    }
  };
</script>

<style lang="scss">
  @import "styles";
</style>
